import type {RouteGrade, RouteGradeSkiing} from '../apis/api-segments.ts';
import {msg} from '@lit/localize';
import type {
  AccommodationCode,
  LandCode,
  RouteCategoryCode,
  ServiceCode,
  StationCode,
} from './layerTypes.ts';

export const ROUTE_CATEGORY_TRANSLATORS: Record<
  LandCode,
  Record<RouteCategoryCode, () => string>
> = {
  hike: {
    national: () => msg('National routes'),
    regional: () => msg('Regional routes'),
    local: () => msg('Local routes'),
    handicap: () => msg('Obstacle-free routes'),
  },
  cycle: {
    national: () => msg('National routes'),
    regional: () => msg('Regional routes'),
    local: () => msg('Local routes'),
    handicap: () => undefined,
  },
  mountainbike: {
    national: () => msg('National routes'),
    regional: () => msg('Regional routes'),
    local: () => msg('Local routes'),
    handicap: () => undefined,
  },
  skate: {
    national: () => msg('National routes'),
    regional: () => msg('Regional routes'),
    local: () => msg('Local routes'),
    handicap: () => undefined,
  },
  canoe: {
    national: () => msg('National routes'),
    regional: () => msg('Regional routes'),
    local: () => undefined,
    handicap: () => undefined,
  },
  crosscountry: {
    national: () => undefined,
    regional: () => undefined,
    local: () =>
      msg('Selected trails', {
        id: 'crosscountry-local-category',
      }),
    handicap: () => undefined,
  },
  winterhike: {
    national: () => undefined,
    regional: () => undefined,
    local: () => msg('Local paths'),
    handicap: () => undefined,
  },
  snowshoe: {
    national: () => undefined,
    regional: () => undefined,
    local: () => msg('Local trails', {id: 'snowshoe-local-category'}),
    handicap: () => undefined,
  },
  sledge: {
    national: () => undefined,
    regional: () => undefined,
    local: () => msg('Local runs'),
    handicap: () => undefined,
  },
};

export const STATION_TRANSLATIONS: Record<StationCode, string> = {
  train: msg('Train'),
  bus: msg('Bus'),
  trambus: msg('Tram / Bus'),
  boat: msg('Boat'),
  cableway: msg('Aerial cableway'),
  funicular: msg('Funicular railway'),
  alpinetaxi: msg('Taxi Alpin'),
  chairlift: msg('Chairlift'),
  telecabin: msg('Telecabin'),
};

export const ACCOMMODATION_TRANSLATIONS: Record<AccommodationCode, string> = {
  backpacker: msg('Backpackers / hostel'),
  bedbreakfast: 'Bed & Breakfast',
  campingsite: msg('Camping site'),
  farmaccom: msg('Farm accommodation'),
  groupaccom: msg('Group accommodation'),
  hotel: msg('Hotel'),
  mountainhut: msg('Mountain hut'),
  sleepingstraw: msg('Sleeping in straw'),
  vacationapptmt: msg('Vacation apartment'),
  youthhostel: msg('Youth Hostel'),
};

export const SERVICE_TRANSLATIONS: Record<ServiceCode, string> = {
  cycleservice: msg('Cycle service'),
  place: msg('Places'),
  sightseeing: msg('Places of interest'),
  velorental: msg('Bicycle and e-bike renting'),
};

export const WS_I18N = {
  ...SERVICE_TRANSLATIONS,
  ...STATION_TRANSLATIONS,
  ...ACCOMMODATION_TRANSLATIONS,
  station: msg('Stop'),
  accommodation: msg('Accommodation'),
  detour: msg('Closure / diversion'),
  swisspark: msg('Swiss Parks'),
  wildlifearea: msg('Designated wildlife areas', {id: 'wildlifearea-layer'}),
  wildlifereserve: msg('Wildlife reserves'),
  alpguarddog: msg('Livestock guardian dogs'),
  slowup: msg('slowUp'),
  shooting: msg('Firing notices'),
  detours: msg('Closure / diversion'),
  photos: msg('Photos'),
  logos: msg('Route-Numbers'),
} as const;

export const GRADE_FITNESS_LEVELS_TRANSLATION: Record<
  RouteGrade,
  () => string
> = {
  easy: () => msg('easy'),
  medium: () => msg('medium'),
  difficult: () => msg('difficult'),
};

export const GRADE_SKIING_TRANSLATION: Record<RouteGradeSkiing, () => string> =
  {
    classic: () => msg('classic'),
    skating: () => msg('skating'),
    both: () => msg('classic+skating'),
  };
